<template>
  <div class="rewards">
    <div class="rewards__header">
      <h2>Latest</h2>
      <div class="rewards__header__actions">
        <label for="expired">Show expired</label>
        <input v-model="showExpired" type="checkbox" id="expired">
        <a :class="`btn ${theme}-bg`" href="https://www.amazon.co.uk/gc/redeem/ref=gc_redeem_new_exp_DesktopRedirect" target="_blank">Use Your Rewards</a>
      </div>
    </div>
    <div class="rewards__container" v-if="activeRewards && activeRewards.length">
      <div
        v-for="(card, key) in activeRewards"
        :key="key"
        class="card-container"
        @mouseover="viewCode(card)"
      >
        <div class="pyro" v-if="card.fireworks">
          <div class="before"></div>
          <div class="after"></div>
        </div>
        <div class="front">
          <span class="price" v-text="`£${card.card_amount}`"></span>
        </div>
        <div class="back">
          <p v-text="card.message"></p>
          <div class="code">
            <span v-text="card.card_code"></span>
            <p class="copy-code" :class="{ 'active' : copied === card.card_code }" @click="copyCode(card)" v-text="(copied === card.card_code) ? 'Copied' : 'Copy To Clipboard'"></p>
          </div>
        </div>
      </div>
    </div>
    <h4 v-else>No Rewards found.</h4>
  </div>
</template>

<script>
import axios from 'axios'

  export default {
    name: 'rewards',
    props: {
      rewards: {
        type: Array,
        required: true
      },
      userId: {
        type: String,
        required: true
      },
        theme: {
        type: String,
        required: false,
        default: 'primary'
      }
    },
    data: () => ({
      copied: '',
      showExpired: false
    }),
    computed: {
      activeRewards () {
        return (this.showExpired) ? this.rewards : this.rewards.filter(r => !r.claimed)
      }
    },
    methods: {
      async viewCode (card) {
        if (card.viewed_at) return
        card.viewed_at = new Date()
        card.fireworks = true
        await axios.patch(`https://abx8y1kjk2.execute-api.eu-west-2.amazonaws.com/production/rewards/${card.id}`)
        setTimeout(() => {
          card.fireworks = false
        }, 3000);
      },
      copyCode (card) {
        let temp = document.createElement('textarea')
        document.body.appendChild(temp)
        temp.value = card.card_code
        temp.select()
        document.execCommand('copy')
        this.copied = card.card_code
        document.body.removeChild(temp)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../scss/rewards';
  @import '../scss/fireworks';

  .rewards {
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: column;

      @media screen and (min-width: 500px) {
        flex-direction: row;
      }

      &__actions {
        input {
          margin-right: 20px;
        }

        .btn {
          padding: 6px 10px;
          color: white;
          border: none;
          font-family: inherit;
          margin-right: 8px;
          text-decoration: none;
        }
      }
    }

    &__container {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }
  }

  .copy-code {
    margin-top: 10px;
    border: solid 1px white;
    transition: all .25s;
    cursor: pointer;

    &:hover {
      background: white;
      color: #232f3e;
    }

    &.active {
      background: white;
      color: #232f3e;
    }
  }
</style>